<template>
  <el-config-provider :locale="locale">
    <router-view/>
  </el-config-provider>
</template>

<script>
import zhCn from "element-plus/lib/locale/lang/zh-cn"
import watermark from 'watermark-dom'
import {formatDate, PURE_DATE_DAY_PATTERN, PURE_DATE_PATTERN} from "@/util/format";

export default {
  name: 'app',
  data() {
    return {
      locale: zhCn
    }
  },
  watch: {},
  mounted() {
    // 确保在路由切换后重新应用水印
    this.$router.afterEach(() => {
      this.$nextTick(() => {
        this.addWatermark();
      });
    });

  },
  created() {
  },
  methods: {
    addWatermark() {

      const userName = localStorage.getItem("userName")
      if (userName) {
        // 获取屏幕宽度并计算百分比位
        const now = new Date();
        let month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1，并补齐两位
        let day = now.getDate().toString().padStart(2, '0'); // 获取当前日期，并补齐两位
        const watermarkOptions = {
          watermark_txt: userName + ' ' + month+day, // 水印内容
          watermark_x_space: 1, //水印x轴间隔
          watermark_y_space: 1, //水印y轴间隔
          watermark_font: '微软雅黑', //水印字体
          watermark_color: 'black', //水印字体颜色
          watermark_fontsize: '14px', //水印字体大小
          watermark_alpha: 0.05, //水印透明度，要求设置在大于等于0.005
          watermark_angle: 25, //水印倾斜度数
          watermark_width: 130, //水印长度
          watermark_height: 70, //水印长度
        };
        watermark.load(watermarkOptions)
      }
    }

  },
  computed: {}
}
</script>
<style scoped>
.watermark-target {
  position: relative; /* 确保容器定位 */
}
</style>
